const deleteActionsStore = {
  toastrSuccess: 'Ação deletada',
  toastrSuccess1: 'deletado com sucesso'
};

export default deleteActionsStore;
